import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Chat: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 21.788 22.239"
    >
      <g id="Group_7571" data-name="Group 7571" transform="translate(0)">
        <path
          id="Path_295"
          data-name="Path 295"
          d="M20.43,16.073H8L5.179,18.89V5.179H16.073V3H3V24.15l5.9-5.9H22.609V10.626H20.43Z"
          transform="translate(-3 -1.911)"
          fill="currentColor"
        />
        <rect
          id="Rectangle_129"
          data-name="Rectangle 129"
          width="8.715"
          height="2.179"
          transform="translate(5.448 5.447)"
          fill="currentColor"
        />
        <rect
          id="Rectangle_130"
          data-name="Rectangle 130"
          width="6.536"
          height="2.179"
          transform="translate(5.448 9.805)"
          fill="currentColor"
        />
        <path
          id="Path_296"
          data-name="Path 296"
          d="M20.268,2a3.268,3.268,0,1,0,3.268,3.268A3.272,3.272,0,0,0,20.268,2Zm0,4.358a1.089,1.089,0,1,1,1.089-1.089A1.09,1.09,0,0,1,20.268,6.358Z"
          transform="translate(-1.748 -2)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default Chat;
